import { useState } from "react";
import p4 from "~/assets/fullstack/p4@3x.png";
import pcp4 from "~/assets/fullstack/pc-p4@3x.png";
import p5 from "~/assets/fullstack/p5@3x.png";
import p6 from "~/assets/fullstack/p6@3x.png";
import p7 from "~/assets/fullstack/p7@3x.png";
import p8 from "~/assets/fullstack/p8@3x.png";
import p9 from "~/assets/fullstack/p9@3x.png";
import p10 from "~/assets/fullstack/p10@3x.png";
import p11 from "~/assets/fullstack/p11@3x.png";
import p12 from "~/assets/fullstack/p12@3x.png";
import p15 from "~/assets/fullstack/p15@3x.png";
import contact from "~/assets/fullstack/contact@3x.png";
import SiteLayout from "components/layout/SiteLayout";

import { Collapse } from "antd";
import { Tab } from "components/camp/tab";
const { Panel } = Collapse;

const Page = () => {
  const [active, setActive] = useState<string>("left");
  const [accordions, setAccordions] = useState<boolean[]>([]);
  const toggleState = (i: number) => {
    const newAccordions = [...accordions];
    newAccordions[i] = !newAccordions[i];
    setAccordions(newAccordions);
  };
  return (
    <SiteLayout largeContainer="true">
      <div className="fs-wrapper">
        <Tab active="left" />
        <div className="block1">
          <div className="content">
            <div className="left">
              <div className="text">远程Web3全栈</div>
              <div className="text">训练营</div>
              <div className="text-en text-en-1 mp-text">JOB TRAINING</div>
              <div className="text-en mp-text">CAMP</div>
              <div className="text-en text-en-1 pc-text">ENGLISH</div>
              <div className="text-en pc-text">JOB TRAINING CAMP</div>
            </div>
            <img src={p4.src} className="p4" />
            <img src={pcp4.src} className="pcp4" />
          </div>
        </div>
        <div className="block2">
          <div className="content">
            <div className="title-w">
              <img src={p5.src} />
              <div className="title">适合学员</div>
            </div>
            <div className="list-w-mb">
              <div className="list-w">
                <div className="item">
                  <img src={p9.src} />
                  <p>前端知识掌握不全、不深，缺乏项⽬实战的同学</p>
                </div>
                <div className="item">
                  <img src={p7.src} />
                  <p>想构建⼀个SEO友好的⽹站的前端开发者</p>
                </div>
                <div className="item">
                  <img src={p6.src} />
                  <p>其他语⾔想转前端的同学</p>
                </div>
                <div className="item">
                  <img src={p8.src} />
                  <p>对AI感兴趣的同学，想在前端、AI领域创业的同学</p>
                </div>
              </div>
              <div className="mb-item">
                <img src={p10.src} />
                <p>
                  想逃离996，对海外⼯作机会、外企、海外远程⼯作等有兴趣的开发者们
                </p>
              </div>
            </div>
            <div className="list-w-pc">
              <div className="list-w">
                <div className="item">
                  <img src={p9.src} />
                  <p>前端知识掌握不全、不深，缺乏项⽬实战的同学</p>
                </div>

                <div className="item">
                  <img src={p6.src} />
                  <p>其他语⾔想转前端的同学</p>
                </div>

                <div className="item">
                  <img src={p10.src} />
                  <p>
                    想逃离996，对海外⼯作机会、外企、海外远程⼯作等有兴趣的开发者们
                  </p>
                </div>
              </div>
              <div className="list-w list-w-b">
                <div className="item">
                  <img src={p7.src} />
                  <p>想构建⼀个SEO友好的⽹站的前端开发者</p>
                </div>
                <div className="item">
                  <img src={p8.src} />
                  <p>对AI感兴趣的同学，想在前端、AI领域创业的同学</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="block3">
          <div className="content">
            <div className="title-w">
              <img src={p5.src} />
              <div className="title">课程介绍</div>
            </div>
            <p className="text">
              本训练营属于买断制，⼀次报名终⽣学习，且享有该课程后续更新内容。
              第 5 期直播开营时间为 2024.4.15 日
            </p>
            <Collapse ghost>
              <Panel
                className={`panel ${!accordions[0] && "without-shadow"}`}
                showArrow={false}
                key={0}
                header={
                  <div className="ac-item-title" onClick={() => toggleState(0)}>
                    <div>TypeScript</div>
                    {accordions[0] ? (
                      <img src={p11.src} />
                    ) : (
                      <img src={p12.src} className="p12" />
                    )}
                  </div>
                }
              >
                <div className="ac-item">
                  <p>1. TypeScript 安装和编译</p>
                  <p>
                    2. 基础理论及原理：数据类型、函数、接⼝、泛型、声明⽂件等
                  </p>
                </div>
              </Panel>
              <Panel
                className={`panel ${!accordions[1] && "without-shadow"}`}
                showArrow={false}
                key={1}
                header={
                  <div className="ac-item-title" onClick={() => toggleState(1)}>
                    <div>React</div>
                    {accordions[1] ? (
                      <img src={p11.src} />
                    ) : (
                      <img src={p12.src} className="p12" />
                    )}
                  </div>
                }
              >
                <div className="ac-item">
                  <p>1. 原⽣组件、⾃定义组件、⾼阶组件和 render props</p>
                  <p>2. React-router，路由配置、懒加载、重定向</p>
                  <p>3. redux & mobx</p>
                  <p>4. 客户端渲染 VS 服务端渲染</p>
                  <p>5. SEO优化</p>
                  <p>6. React状态管理</p>
                  <p>
                    7. 性能优化：性能分析⼯具；编译阶段、路由过程、更新阶段等
                  </p>
                </div>
              </Panel>
              <Panel
                className={`panel ${!accordions[2] && "without-shadow"}`}
                showArrow={false}
                key={2}
                header={
                  <div className="ac-item-title" onClick={() => toggleState(2)}>
                    <div>Next.js的原理及使用</div>
                    {accordions[2] ? (
                      <img src={p11.src} />
                    ) : (
                      <img src={p12.src} className="p12" />
                    )}
                  </div>
                }
              >
                <div className="ac-item">
                  <p>1. 掌握内置组件、组件导航</p>
                  <p>2. 全局监听路由、动态路由、路由传参</p>
                  <p>3. ⾃定义布局</p>
                  <p>4. 封装⽹络请求</p>
                  <p>5. SSG、SSR、ISR、CSR渲染</p>
                  <p>6. 同构的原理和意义</p>
                </div>
              </Panel>
              <Panel
                className={`panel ${!accordions[3] && "without-shadow"}`}
                showArrow={false}
                key={3}
                header={
                  <div className="ac-item-title" onClick={() => toggleState(3)}>
                    <div>实战项⽬-ChatGPT个⼈站及商业化实战</div>
                    {accordions[3] ? (
                      <img src={p11.src} />
                    ) : (
                      <img src={p12.src} className="p12" />
                    )}
                  </div>
                }
              >
                <div className="ac-item ac-item-pc">
                  <div className="item">
                    <p className="title">ChatGPT账号注册、模型API</p>
                    <p>1. ChatGPT账号注册</p>
                    <p>2. OpenAI接⼝api解析及基于AccessToken的代理模式</p>
                    <div className="line"></div>
                  </div>
                  <div className="item">
                    <p className="title">开源库ChatGPT Next Web源码解析</p>
                    <p>1. 代码结构梳理、主要组件讲解</p>
                    <p>2. ⻚⾯响应式</p>
                    <p>3. 对话系统的实现</p>
                    <div className="line"></div>
                  </div>
                  <div className="item">
                    <p className="title">界⾯优化、功能完善</p>
                    <p>1. 引⼊个性化UI</p>
                    <p>2. 实现邀请码功能</p>
                    <p>
                      3. 登录系统的前后端接⼊（MongoDB Online）、邮件通知系统
                    </p>
                    <p>4. ⽀付功能及相关逻辑</p>
                    <p>5. 实现提⽰词词库</p>
                    <div className="line"></div>
                  </div>
                  <div className="item">
                    <p className="title">serverless/服务器部署及商业化开发</p>
                    <p>1. 项⽬Vercel部署及配置</p>
                    <p>2. 服务器购买、选择、部署</p>
                    <p>3. Nginx配置、域名配置</p>
                    <p>4. 防封策略</p>
                  </div>
                </div>
              </Panel>
              <Panel
                className={`panel ${!accordions[4] && "without-shadow"}`}
                showArrow={false}
                key={4}
                header={
                  <div className="ac-item-title" onClick={() => toggleState(4)}>
                    <div>Web3区块链课程</div>
                    {accordions[4] ? (
                      <img src={p11.src} />
                    ) : (
                      <img src={p12.src} className="p12" />
                    )}
                  </div>
                }
              >
                {/* <div className="ac-item">
                  <p>1. 区块链的基础原理</p>
                  <p>2. MetaMask</p>
                  <p>3. Ethereum技术</p>
                  <p>4. Solidity</p>
                  <p>5. web3.py</p>
                  <p>6. OpenZeppelin</p>
                  <p>7. ethers.js </p>
                  <p>8. 框架：Truflle、HardHat</p>
                  <p>9. 编写Dapp实战</p>
                  <p>10. web3.js调用合约</p>
                  <p>11. 智能合约安全</p>
                </div> */}
                <div className="ac-item ac-item-pc">
                  <div className="item">
                    <p className="title">一、区块链基础与概念理解</p>
                    <p className="sub-title">1.1 区块链技术概述</p>
                    <p className="detail">区块链定义、特点和应用场景</p>
                    <p className="sub-title">1.2 密码学基础</p>
                    <p className="detail">哈希函数、公钥私钥、数字签名</p>
                    <p className="sub-title">1.3 共识机制介绍</p>
                    <p className="detail">工作量证明（PoW）、权益证明（PoS）</p>
                    <p className="sub-title">1.4 比特币与以太坊生态简介</p>
                    <p className="detail">比特币与以太坊基本原理和区别</p>
                    <p className="sub-title">1.5 公链生态与联盟链介绍</p>
                    <p className="detail">EVM及其他公链、联盟链</p>
                    <div className="line"></div>
                  </div>
                  <div className="item">
                    <p className="title">二、初识以太坊和智能合约基础</p>
                    <p className="sub-title">2.1 以太坊生态概述</p>
                    <p className="detail">EVM、以太坊账户、Gas机制</p>
                    <p className="sub-title">2.2 智能合约基础</p>
                    <p className="detail">什么是智能合约、Solidity基础</p>
                    <p className="sub-title">2.3 开发环境搭建</p>
                    <p className="detail">MetaMask钱包、Remix IDE</p>
                    <p className="sub-title">
                      2.4 发布第一个智能合约-属于自己的代币
                    </p>
                    <p className="detail">
                      ERC20代币合约部署与交互、区块链浏览器
                    </p>
                    <div className="line"></div>
                  </div>
                  <div className="item">
                    <p className="title">三、进阶智能合约开发</p>
                    <p className="sub-title">3.1 Solidity进阶</p>
                    <p className="detail">继承、接口、库等的使用</p>
                    <p className="sub-title">3.2 开发工具链</p>
                    <p className="detail">
                      Hardhat、Foundry、OpenZeppelin库介绍和实践
                    </p>
                    <p className="sub-title">3.3 NFT开发到上线opensea</p>
                    <p className="detail">
                      ERC721标准、NFT智能合约开发与部署、IPFS基础和应用实践
                    </p>
                    <div className="line"></div>
                  </div>
                  <div className="item">
                    <p className="title">四、DApp开发与前端集成</p>
                    <p className="sub-title">4.1 DApp架构与开发流程</p>
                    <p className="detail">DApp概念、架构理解</p>
                    <p className="sub-title">
                      4.2 infrua 和 alchemy 节点服务介绍和使用
                    </p>
                    <p className="sub-title">4.3 Web3.js与Ethers.js库介绍</p>
                    <p className="detail">与智能合约交互</p>
                    <p className="sub-title">4.4 前端集成实践</p>
                    <p className="detail">React与Web3.js集成示例</p>
                    <p className="sub-title">4.5 完整DApp项目实战</p>
                    <p className="detail">综合完成一个简单的DApp项目</p>
                    <div className="line"></div>
                  </div>
                  <div className="item">
                    <p className="title">五、区块链应用开发进阶</p>
                    <p className="sub-title">5.1 高级智能合约功能</p>
                    <p className="detail">时间锁、权限控制、Merkle树等</p>
                    <p className="sub-title">5.2 去中心化服务</p>
                    <p className="detail">The grapth、预言机、ETH json-rpc等</p>
                    <p className="sub-title">5.3 安全性与优化</p>
                    <p className="detail">智能合约安全最佳实践、Gas优化技巧</p>
                    <p className="sub-title">5.4 行业趋势与案例分析</p>
                    <p className="detail">探索DeFi、GameFi等热门领域</p>
                    <div className="line"></div>
                  </div>
                  <div className="item">
                    <p className="title">六、区块链漂流瓶SociaFi项目</p>
                    <p className="sub-title">6.1 合约开发</p>
                    <p className="detail">
                      solidity、ERC20、openzepplin、chainlink预言机、内联汇编
                    </p>
                    <p className="sub-title">6.2 合约测试与部署</p>
                    <p className="detail">hardhat、typescript、slither</p>
                    <p className="sub-title">6.3 前端开发与交互集成</p>
                    <p className="detail">
                      ethers.js、React、web3钱包、ipfs客户端、infura节点服务
                    </p>
                  </div>
                  <div className="item">
                    <p className="title">七、课程总结与指导</p>
                    <p className="sub-title">7.1 课程重点回顾与面试指导</p>
                    <p className="detail">重要概念和技能点回顾</p>
                  </div>
                  {/* <div className="item">
                    <p className="title">六、合约开发</p>
                    <p className="sub-title">
                      6.1
                      solidity、ERC20、openzepplin、chainlink预言机、内联汇编
                    </p>
                    <ul className="ml-30">
                      <li>逻辑业务的实现、合约事件监听、接口合约、治理代币</li>
                      <li>openzepplin标准库的使用</li>
                      <li>代理可升级合约</li>
                      <li>权限管理、安全控制</li>
                      <li>chainlink预言机的随机数使用</li>
                      <li>利用内联汇编针对存储的访问优化等</li>
                    </ul>
                  </div>
                  <div className="item">
                    <p className="title">七、合约测试与部署</p>
                    <p className="sub-title">
                      7.1 hardhat、typescript、slither
                    </p>
                    <ul className="ml-30">
                      <li>hardhat部署调试</li>
                      <li>ts脚本测试</li>
                      <li>slither静态分析</li>
                    </ul>
                  </div>
                  <div className="item">
                    <p className="title">八、前端开发与交互集成</p>
                    <p className="sub-title">
                      8.1 ethers.js、React、web3钱包、ipfs客户端、infura节点服务
                    </p>
                    <ul className="ml-30">
                      <li>React前端框架</li>
                      <li>ethers.js库</li>
                      <li>web3钱包交互</li>
                      <li>ipfs客户端创建验证调用等</li>
                      <li>infura中ipfs服务</li>
                    </ul>
                  </div>
                  <div className="item">
                    <p className="title">九、课程总结与指导</p>
                    <p className="sub-title">9.1 课程重点回顾与面试指导</p>
                    <p className="detail">重要概念和技能点回顾</p>
                  </div> */}
                </div>
              </Panel>
            </Collapse>
          </div>
        </div>
        <div className="block4">
          <div className="content">
            <div className="title-w">
              <img src={p5.src} />
              <div className="title">服务保障</div>
            </div>
            <div className="wrapper">
              <div className="left">
                <div className="item">
                  <div className="icon">1</div>
                  <p>课程所有资料、源码均会分享</p>
                </div>
                <div className="item">
                  <div className="icon">2</div>
                  <p>所有直播均有录播，且享有该课程后续更新观看权限</p>
                </div>
                <div className="item">
                  <div className="icon">3</div>
                  <p>可以定制化开发⾃⼰的⼀套Chatgpt⽹站</p>
                </div>
                <div className="item">
                  <div className="icon">4</div>
                  <p>
                    优先推荐全球优质远程、全职、兼职⼯作机会，⽆限次内推服务
                  </p>
                </div>
                <div className="item">
                  <div className="icon">5</div>
                  <p>了解国外前端主流技术栈、开发协作及团队沟通⼯具</p>
                </div>
                <div className="item">
                  <div className="icon">6</div>
                  <p>对外企面试官</p>
                </div>
                <div className="item">
                  <div className="icon">7</div>
                  <p>结识⼀群和你有相同⽬标，⼀起奋⽃的⼩伙伴</p>
                </div>
              </div>
              <img className="right" src={p15.src} />
            </div>
          </div>
        </div>
        <div className="block5">
          <div className="content">
            <div className="title-w">
              <img src={p5.src} />
              <div className="title">老师简介</div>
            </div>
            <div className="list-w">
              <div className="item">
                <div className="name">Allan</div>
                <p className="desc">
                  本科毕业于上海交通⼤学，于美国研究⽣毕业后在Amazon从事软件开发⼯程师⼯作。资深外企⾯试官，了解外企⼤⼚⾯试的标准和套路，曾⼿把⼿帮助多名求职者获得FAANG
                  等公司的offer。
                </p>
              </div>
              <div className="item">
                <div className="name">砾羽</div>
                <div className="desc">
                  <p>曾就职于字节、美团。</p>
                  <p>
                    有多年GIS开发、搭建系统、前端工程化开发经验。
                    <br />
                    6年企业级BI/内容平台系统需求分析、设计与架构经验。
                    <br />
                    2年远程工作经验。
                  </p>
                </div>
              </div>
              <div className="item">
                <div className="name">Jenkin</div>
                <div className="desc">
                  <p>
                    毕业于瑞典皇家理工学院，曾在阿里、top
                    DeFi项目和web3安全公司工作，专注于加密和区块链行业6年，有多项区块链相关专利和论文，带领团队斩获多项ETH
                    hackathon头奖，拥有近万人社区项目
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="block6">
          <div className="content">
            <div className="title-w">
              <img src={p5.src} />
              <div className="title title-white">价格</div>
            </div>
            <div className="pc">
              <div className="left">
                <div className="price"> 价格</div>
                <div className="list-w">
                  <div className="item">
                    <div className="top">原价</div>
                    <div className="bottom number-with-line">
                      <span>￥</span>6225
                    </div>
                  </div>
                  <div className="item">
                    <div className="top top-after">现价</div>
                    <div className="bottom">
                      <span>￥</span>4980
                    </div>
                  </div>
                </div>
              </div>
              <div className="wrapper">
                <img src={contact.src} className="contact" />
                <div className="contact-text">
                  最后，有疑问或报名参加请联系训练营负责⼈
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SiteLayout>
  );
};
export default Page;
